import { apiClient } from './api/apiClient';

export interface IUIPreferences {
  discoveryDialogDismissed: boolean;
  discoveryMode?: boolean;
  searchRadiusMiles?: number;
  bucketListLayout?: 'horizontal' | 'vertical';
}

export interface IUserSettings {
  preferences?: IUIPreferences;
}

const settingsService = {
  async getUIPreferences(): Promise<IUIPreferences> {
    const response = await apiClient.get<{ preferences: IUIPreferences }>(
      '/settings/preferences'
    );
    return response.data.preferences ?? { discoveryDialogDismissed: false };
  },

  async updateUIPreferences(
    prefs: Partial<IUIPreferences>
  ): Promise<IUIPreferences> {
    const response = await apiClient.patch<{ preferences: IUIPreferences }>(
      '/settings/preferences',
      prefs
    );
    return response.data.preferences;
  }
};

export default settingsService;
